var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloudOffFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7 18.539q-2.091 0-3.545-1.435Q2 15.67 2 13.608q0-1.725 1.08-3.07a4.8 4.8 0 0 1 2.784-1.726q.067-.18.136-.348.067-.168.136-.37L3 5.002a.84.84 0 0 1-.25-.628q0-.381.25-.627a.87.87 0 0 1 .636-.247q.387 0 .637.247l15.454 15.24a.87.87 0 0 1 .262.616.83.83 0 0 1-.262.639.9.9 0 0 1-.625.258.9.9 0 0 1-.648-.236l-1.772-1.726zm13.727-1.121L8.41 5.293a6.4 6.4 0 0 1 1.693-.818A6.3 6.3 0 0 1 12 4.195q2.66 0 4.511 1.826 1.853 1.827 1.853 4.45 1.567.178 2.602 1.333t1.034 2.7q0 .875-.34 1.625-.342.75-.933 1.289"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudOffFill);
export default __webpack_public_path__ + "static/media/cloud_off_fill.a43247dedc50f5e83f7891a4cd7be5ec.svg";
export { ForwardRef as ReactComponent };